<template>
    <div>
        <div class="px-3 py-1 bg-theme" :class="{'progress-bar-striped progress-bar-animated': ballotStateIn('calculating_result')}">
            <template v-if="ballotStateIn(['open','countdown'])">
                <div class="d-flex d-sm-block justify-content-between align-items-center">
                    <span class="lead">{{ $t('js.ballot.open') }}</span>
                    <span class="lead float-sm-right ml-3 text-monospace pb-sm-0" style="height: 0px; padding-bottom: 20px">
                        <b v-if="ballot.disableAt" class="mb-0"><Countdown :end-time="ballot.disableAt" @timesUp="updateStatus()"/></b>
                    </span>
                </div>
            </template>
            <template v-else-if="ballotStateIn('calculating_result')">
                <p class="lead mb-0">{{ $t('js.result.status.result_calculating') }}</p>
            </template>
            <template v-else-if="ballotStateIn('finished')">
                <p class="lead mb-0">{{ $t('js.result.status.result_ready') }}</p>
            </template>
            <template v-else-if="ballotStateIn('new')">
                <span class="lead">{{ $t('js.ballot.not_yet_open') }}</span>
            </template>
            <template v-else-if="ballotStateIn('closed')">
                <span class="lead">{{ $t('js.ballot.has_closed') }}</span>
            </template>
        </div>
    </div>

</template>

<script>
    import {mapActions} from 'vuex'
    import Countdown from "../shared/Countdown";

    export default {
        name: "BallotStatus",
        props: {
            sticky: {
                type: Object,
                required: true
            }
        },
        computed: {
          ballot(){
              return this.sticky.ballot
          }
        },
        components: {
            Countdown
        },
        methods: {
            ...mapActions(['updateStatus']),
            ballotStateIn(ballotStates) {
                if(this.ballot){
                    if(Array.isArray(ballotStates)){
                        return ballotStates.includes(this.ballot.state)
                    } else {
                        return ballotStates === this.ballot.state
                    }
                }
                return false
            }
        }
    }
</script>